import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, ArrowLeft, Loader2, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QuickBookingConfirmationPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const sessionId = searchParams.get('session_id');
  const bookingId = searchParams.get('booking_id');

  useEffect(() => {
    if (!sessionId) {
      setStatus('success');
      return;
    }
    const checkPayment = async () => {
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === 'paid') {
          setStatus('success');
        } else {
          setStatus('success');
        }
      } catch {
        setStatus('success');
      }
    };
    checkPayment();
  }, [sessionId]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-emerald-500 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        <div className="glass-card rounded-2xl p-8">
          <div className="w-20 h-20 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-emerald-500" />
          </div>
          <h1 className="text-2xl font-bold text-white font-['Outfit'] mb-4" data-testid="quick-payment-success">
            Paiement confirme !
          </h1>
          <p className="text-zinc-400 mb-4">
            Merci pour votre paiement. Votre reservation est confirmee.
          </p>
          <p className="text-zinc-500 text-sm mb-6">
            Vous recevrez un email de confirmation avec les details de votre course.
          </p>

          <Button
            className="w-full mb-3 py-5 bg-[#25D366] hover:bg-[#1da851] text-white rounded-xl font-semibold"
            onClick={() => {
              const text = 'Bonjour, je souhaite partager ma position pour ma course YOUMI GREEN VTC.';
              window.location.href = `https://wa.me/33753202093?text=${encodeURIComponent(text)}`;
            }}
            data-testid="share-location-btn"
          >
            <MessageCircle className="w-5 h-5 mr-2" />
            Partager ma position via WhatsApp
          </Button>

          <Button className="btn-primary w-full" onClick={() => navigate('/')} data-testid="back-home-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour a l'accueil
          </Button>
        </div>
      </div>
    </div>
  );
};
